(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raket-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.rk-mobile-menu[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  document.addEventListener('click', (event) => {
    const searchLink = event.target.closest('.rk-search-link');
    if (searchLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
      const modal = document.getElementById('search-modal');
      if (typeof modal?.showDialog === 'function') {
        event.preventDefault();
        document.querySelectorAll('.rk-mobile-menu[open]').forEach((menu) => { menu.open = false; });
        modal.showDialog();
      }
    }
    document.querySelectorAll('.rk-mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raket-password"] && !Shopify.designMode) return;
  try {
    
function setupRaketVideo() {
  document.querySelectorAll('.rp').forEach(root => {
    const video = root.querySelector('video');
    if (!video || video.dataset.ready) return;
    video.dataset.ready = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.loop = true;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const play = () => {
      if (!motion.matches && !document.hidden) video.play().catch(() => {});
    };
    const respectMotion = () => {
      root.classList.toggle('rp-reduced-motion', motion.matches);
      if (motion.matches) video.pause();
      else play();
    };
    motion.addEventListener('change', respectMotion);
    video.addEventListener('canplay', play, { once: true });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) video.pause();
      else play();
    });
    respectMotion();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupRaketVideo);
else setupRaketVideo();
document.addEventListener('shopify:section:load', setupRaketVideo);

  } catch(e) { console.error(e); }
})();
})();
